import { Reward, RewardFormData, RewardList } from "../types/reward";
import { get, post } from "./fetch.core";

export interface RewardListFilter {
  paging: {
    page: number;
    size: number;
  };
  userIds: string[];
}
async function create(data: RewardFormData) {
  const rst = await post("/admin/reward/create", data);
  return rst.data;
}

export async function loadRewards({ paging, userIds }: RewardListFilter) {
  const rst = await post<RewardList>("/admin/reward/list", { paging, userIds });
  return rst.data;
}

async function edit(data: RewardFormData, id: string) {
  const rst = await post(`/admin/reward/edit?rewardId=${id}`, data);
}

async function getOne(id: string) {
  const rst = await get<Reward>(`/admin/reward/get?rewardId=${id}`);
  return rst.data;
}

async function addRewardRecord(data: { userId: string; points: number; expirationDate: string }) {
  const rst = await post<Reward>("/admin/reward/addRewardRecord", data);
  return rst.data;
}

async function adjustBalance(data: { userId: string; points: number; expirationDate: string }) {
  const rst = await post<Reward>("/admin/reward/adjustBalance", data);
  return rst.data;
}

const obj = {
  loadRewards,
  create,
  edit,
  getOne,
  addRewardRecord,
  adjustBalance,
};

export default obj;
